import { publicGetVariantPricing } from "@babackapp/private-api-client/client/public-get-variant-pricing";
import type { CatalogProductVariant } from "@babackapp/private-api-client/client/use-catalog-product";
import type { CartItem } from "@babackapp/return-widget-components/types";

/** Human-readable variant label, e.g. "M / Blue". */
export function variantLabel(variant: CatalogProductVariant): string {
  return (
    variant.title ??
    variant.selectedOptions.map((o) => o.value).join(" / ")
  );
}

/**
 * Build a Shop Now cart item from a selected catalogue variant, fetching the
 * live catalogue price (falls back to 0 if unavailable — the backend charges
 * the correct amount from Shopify Admin live prices regardless).
 */
export async function buildCartItem(
  shopId: string,
  productTitle: string,
  variant: CatalogProductVariant,
  imageUrl: string | null,
): Promise<CartItem> {
  const pricing = await publicGetVariantPricing(shopId, [variant.id]).catch(
    () => [],
  );
  const price = pricing.find((p) => p.variantId === variant.id)?.price ?? 0;

  return {
    variantId: variant.id,
    quantity: 1,
    price,
    title: productTitle,
    sku: null,
    image: imageUrl,
  };
}
